// GÉNÉRÉ par `php bin/console app:limits:export` : ne pas modifier à la main.
// Les règles de saisie des champs texte, lues dans les entités (Rules) :
// longueur maximale (null : pas de limite) et caractère obligatoire.

export interface Limit {
    readonly max: number | null;
    readonly required: boolean;
}

export const LIMITS = {
    AbsenceJustification: {
        documentName: { max: 160, required: false },
        documentType: { max: 60, required: false },
        reason: { max: 255, required: false },
        recordedByName: { max: 255, required: false },
    },
    AbsenceType: {
        code: { max: 20, required: true },
        label: { max: 80, required: true },
    },
    AcademicYear: {
        label: { max: 20, required: true },
    },
    AccountInvitation: {
        emailCanonical: { max: 180, required: false },
        tokenHash: { max: 64, required: false },
    },
    AdminAuditLog: {
        actorLabel: { max: 255, required: false },
        ipAddress: { max: 45, required: false },
        targetLabel: { max: 255, required: false },
        userAgent: { max: 255, required: false },
    },
    Application: {
        cvName: { max: 160, required: false },
        letter: { max: 8000, required: false },
    },
    ArchivedCredit: {
        comment: { max: null, required: false },
    },
    ArchivedInvoice: {
        number: { max: 40, required: false },
        payerType: { max: 60, required: false },
        trainingLabel: { max: 255, required: false },
        yearLabel: { max: 60, required: false },
    },
    ArchivedInvoiceLine: {
        label: { max: 255, required: false },
    },
    ArchivedPayment: {
        comment: { max: null, required: false },
        method: { max: 20, required: false },
    },
    Assessment: {
        label: { max: 120, required: true },
        validatedByName: { max: 255, required: false },
    },
    AssessmentType: {
        code: { max: 20, required: true },
        label: { max: 80, required: true },
    },
    AttendanceRecord: {
        recordedByName: { max: 255, required: false },
    },
    AttendanceWaiver: {
        grantedByName: { max: 255, required: false },
        reason: { max: 255, required: true },
    },
    AuthenticationLog: {
        emailAttempted: { max: 180, required: false },
        ipAddress: { max: 45, required: false },
        userAgent: { max: 255, required: false },
    },
    BrandingVersion: {
        byName: { max: 255, required: false },
        change: { max: 10, required: false },
        emblemKey: { max: 80, required: false },
        logoKey: { max: 80, required: false },
        nameAr: { max: 255, required: false },
        nameEn: { max: 255, required: false },
        nameFr: { max: 255, required: false },
    },
    CalendarPeriod: {
        label: { max: 120, required: true },
    },
    Campaign: {
        label: { max: 160, required: true },
    },
    ChatMessage: {
        authorName: { max: 255, required: false },
        body: { max: 5000, required: false },
    },
    ClassGroup: {
        name: { max: 60, required: true },
    },
    CommunicationAttachment: {
        mime: { max: 60, required: false },
        name: { max: 160, required: false },
    },
    Contact: {
        observations: { max: null, required: false },
        otherOrganisationName: { max: 255, required: false },
    },
    ContactType: {
        name: { max: 255, required: true },
    },
    Conversation: {
        title: { max: 120, required: false },
    },
    CreditNote: {
        number: { max: 40, required: false },
        reason: { max: 500, required: true },
    },
    DefenseDay: {
        place: { max: 120, required: false },
    },
    Deliberation: {
        closedByName: { max: 255, required: false },
        comment: { max: 2000, required: false },
    },
    Department: {
        label: { max: 120, required: true },
    },
    Diploma: {
        name: { max: 160, required: true },
    },
    DiplomaOption: {
        name: { max: 160, required: true },
    },
    DisciplinaryField: {
        label: { max: 120, required: true },
    },
    Discount: {
        label: { max: 120, required: true },
    },
    DocumentEvent: {
        actorName: { max: 255, required: false },
        detail: { max: 255, required: false },
        kind: { max: 12, required: false },
        result: { max: 12, required: false },
    },
    DocumentJob: {
        createdByName: { max: 255, required: false },
        kind: { max: 12, required: false },
        label: { max: 255, required: false },
        returnReason: { max: null, required: false },
        signedByName: { max: 255, required: false },
        source: { max: 12, required: false },
        state: { max: 10, required: false },
    },
    DocumentSettings: {
        place: { max: 120, required: false },
        tagline: { max: 255, required: false },
    },
    DocumentSignatory: {
        name: { max: 160, required: false },
        title: { max: 120, required: true },
    },
    DocumentSignatureCode: {
        codeHash: { max: 64, required: false },
    },
    DocumentSigner: {
        title: { max: 120, required: false },
    },
    DocumentTemplate: {
        category: { max: 12, required: false },
        code: { max: 80, required: false },
        kind: { max: 12, required: false },
        legacyCode: { max: 100, required: false },
        name: { max: 120, required: false },
        paper: { max: 14, required: false },
        source: { max: 12, required: false },
    },
    DocumentTemplateAssignment: {
        kind: { max: 12, required: false },
        titleCredit: { max: 120, required: false },
        titleNormal: { max: 120, required: false },
        titleRetake: { max: 120, required: false },
        titleShared: { max: 120, required: false },
    },
    DocumentTemplateVersion: {
        createdByName: { max: 255, required: false },
        note: { max: 255, required: false },
        publishedByName: { max: 255, required: false },
    },
    Employee: {
        employeeNumber: { max: 20, required: false },
    },
    EnrolmentEvent: {
        reason: { max: 500, required: false },
    },
    FeeService: {
        label: { max: 160, required: true },
    },
    FinanceSequence: {
        kind: { max: 20, required: false },
    },
    FinanceSettings: {
        address: { max: 1000, required: false },
        businessId: { max: 30, required: false },
        creditNotePattern: { max: 30, required: true },
        currency: { max: 3, required: true },
        footer: { max: 1000, required: false },
        invoicePattern: { max: 30, required: true },
        legalName: { max: 255, required: false },
        receiptPattern: { max: 30, required: true },
        refundPattern: { max: 30, required: true },
        taxId: { max: 30, required: false },
        tradeRegister: { max: 30, required: false },
    },
    FollowUp: {
        authorName: { max: 255, required: false },
        observations: { max: 4000, required: false },
    },
    FollowUpType: {
        label: { max: 120, required: true },
    },
    HousingAllocation: {
        checkInNote: { max: 2000, required: false },
        checkOutNote: { max: 2000, required: false },
        keyGivenBy: { max: 255, required: false },
        keyLabel: { max: 60, required: false },
        priceLabel: { max: 255, required: false },
        proposedBy: { max: 255, required: false },
        releaseReason: { max: 255, required: false },
    },
    HousingApplication: {
        decisionNote: { max: 2000, required: false },
        emergencyContact: { max: 160, required: false },
        gender: { max: 1, required: false },
        homeCity: { max: 80, required: false },
        needs: { max: 1000, required: false },
        number: { max: 30, required: false },
    },
    HousingBed: {
        label: { max: 40, required: true },
    },
    HousingCampaign: {
        description: { max: 2000, required: false },
        finalMessage: { max: 2000, required: false },
        label: { max: 120, required: true },
        provisionalMessage: { max: 2000, required: false },
    },
    HousingCampus: {
        address: { max: 255, required: false },
        code: { max: 20, required: true },
        name: { max: 120, required: true },
    },
    HousingChecklist: {
        label: { max: 120, required: true },
    },
    HousingEvent: {
        actorName: { max: 255, required: false },
        kind: { max: 30, required: false },
        note: { max: 2000, required: false },
    },
    HousingFile: {
        kind: { max: 20, required: false },
        mime: { max: 60, required: false },
        name: { max: 160, required: true },
        note: { max: 255, required: false },
        uploadedByName: { max: 255, required: false },
    },
    HousingInspection: {
        block: { max: 40, required: false },
        floor: { max: 40, required: false },
        inspectorName: { max: 255, required: false },
        note: { max: 2000, required: false },
    },
    HousingInspectionRoom: {
        note: { max: 2000, required: false },
        present: { max: 255, required: false },
    },
    HousingPayment: {
        decidedByName: { max: 255, required: false },
        reference: { max: 80, required: false },
        refusal: { max: 255, required: false },
        submittedByName: { max: 255, required: false },
    },
    HousingProvider: {
        email: { max: 180, required: false },
        name: { max: 120, required: true },
        phone: { max: 40, required: false },
        trades: { max: 160, required: false },
    },
    HousingQuota: {
        label: { max: 80, required: true },
        value: { max: 60, required: false },
    },
    HousingRepair: {
        description: { max: 2000, required: false },
        number: { max: 30, required: false },
        reportedByName: { max: 255, required: false },
        title: { max: 160, required: true },
    },
    HousingRepairCategory: {
        label: { max: 80, required: true },
    },
    HousingRequiredDocument: {
        condition: { max: 120, required: false },
        label: { max: 120, required: true },
    },
    HousingRoom: {
        block: { max: 40, required: false },
        floor: { max: 40, required: false },
        note: { max: 2000, required: false },
        number: { max: 30, required: true },
    },
    HousingRoomType: {
        label: { max: 80, required: true },
    },
    HousingSettings: {
        instalments: { max: 160, required: false },
    },
    IdentityProvider: {
        clientId: { max: 255, required: false },
        clientSecretEncrypted: { max: null, required: false },
        displayName: { max: 100, required: true },
        issuer: { max: 255, required: false },
        tenantId: { max: 255, required: false },
    },
    Institution: {
        code: { max: 20, required: true },
        name: { max: 255, required: true },
    },
    Internship: {
        closingReason: { max: 255, required: false },
        juryComment: { max: 4000, required: false },
        missions: { max: 4000, required: false },
        place: { max: 160, required: false },
        source: { max: 10, required: false },
        topic: { max: 2000, required: false },
    },
    InternshipDocument: {
        fileName: { max: 160, required: false },
        label: { max: 120, required: true },
    },
    InternshipType: {
        label: { max: 120, required: true },
    },
    InternshipTypeComponent: {
        label: { max: 120, required: true },
    },
    InternshipTypeDocument: {
        label: { max: 120, required: true },
    },
    Invoice: {
        cancelReason: { max: 500, required: false },
        currency: { max: 3, required: false },
        number: { max: 40, required: false },
    },
    InvoiceLine: {
        label: { max: 255, required: false },
        reason: { max: 500, required: false },
    },
    IssuedDocument: {
        cancelReason: { max: null, required: false },
        cancelledByName: { max: 255, required: false },
        digest: { max: 64, required: false },
        issuedByName: { max: 255, required: false },
        reference: { max: 48, required: false },
        signedByName: { max: 255, required: false },
    },
    JuryBonus: {
        grantedByName: { max: 255, required: false },
        reason: { max: 2000, required: true },
    },
    LearningAccommodation: {
        grantedByName: { max: 255, required: false },
        reason: { max: null, required: false },
    },
    LearningAnswer: {
        comment: { max: null, required: false },
        fileMime: { max: 150, required: false },
        fileName: { max: 200, required: false },
        gradedByName: { max: 255, required: false },
    },
    LearningAttempt: {
        agent: { max: 255, required: false },
        ip: { max: 64, required: false },
        receipt: { max: 40, required: false },
    },
    LearningAttemptEvent: {
        detail: { max: 255, required: false },
        kind: { max: 20, required: false },
    },
    LearningQuestion: {
        chapter: { max: 120, required: false },
        createdByName: { max: 255, required: false },
        difficulty: { max: 10, required: false },
        outcome: { max: 120, required: false },
    },
    LearningQuestionVersion: {
        body: { max: null, required: false },
        feedback: { max: null, required: false },
    },
    LearningQuiz: {
        composition: { max: 10, required: false },
        controlledByName: { max: 255, required: false },
        createdByName: { max: 255, required: false },
        feedback: { max: 10, required: false },
        keep: { max: 10, required: false },
        navigation: { max: 12, required: false },
        rejection: { max: null, required: false },
        returnReason: { max: null, required: false },
        title: { max: 160, required: false },
        transferredByName: { max: 255, required: false },
        validatedByName: { max: 255, required: false },
    },
    LearningResource: {
        body: { max: null, required: false },
        conditionId: { max: 36, required: false },
        conditionType: { max: 10, required: false },
        createdByName: { max: 255, required: false },
        fileName: { max: 200, required: false },
        linkStatus: { max: 10, required: false },
        mime: { max: 150, required: false },
        title: { max: 200, required: false },
        url: { max: 1000, required: false },
    },
    LearningSection: {
        eventId: { max: 36, required: false },
        kind: { max: 10, required: false },
        label: { max: 160, required: false },
    },
    LearningSettings: {
        absenceTypeId: { max: 36, required: false },
        defaultFeedback: { max: 10, required: false },
    },
    LearningSpace: {
        copiedFrom: { max: 36, required: false },
        layout: { max: 10, required: false },
    },
    LearningSyllabus: {
        template: { max: 40, required: false },
        updatedByName: { max: 255, required: false },
    },
    LearningSyllabusVersion: {
        publishedByName: { max: 255, required: false },
    },
    LetterGrade: {
        letter: { max: 4, required: true },
    },
    LetterScale: {
        name: { max: 120, required: true },
    },
    LibraryAuthority: {
        dates: { max: 40, required: false },
        firstName: { max: 160, required: false },
        kind: { max: 12, required: false },
        name: { max: 255, required: false },
        nationality: { max: 80, required: false },
        note: { max: 120, required: false },
    },
    LibraryCard: {
        kind: { max: 10, required: false },
        number: { max: 40, required: false },
        state: { max: 10, required: false },
    },
    LibraryClearance: {
        digest: { max: 64, required: false },
        issuedByName: { max: 255, required: false },
        purpose: { max: 12, required: false },
        reference: { max: 40, required: false },
    },
    LibraryContribution: {
        role: { max: 12, required: false },
    },
    LibraryCourseLink: {
        note: { max: 160, required: false },
    },
    LibraryEdition: {
        audience: { max: 160, required: false },
        collectionNumber: { max: 30, required: false },
        cote: { max: 40, required: false },
        coverKey: { max: 64, required: false },
        dewey: { max: 20, required: false },
        digitalUrl: { max: 500, required: false },
        docType: { max: 20, required: false },
        editionStatement: { max: 160, required: false },
        internalNote: { max: null, required: false },
        isbn: { max: 13, required: false },
        issn: { max: 9, required: false },
        parallelTitle: { max: 500, required: false },
        place: { max: 120, required: false },
        publicNote: { max: null, required: false },
        searchText: { max: null, required: false },
        subtitle: { max: 500, required: false },
        summary: { max: null, required: false },
        title: { max: 500, required: false },
        updatedByName: { max: 255, required: false },
        volumeTitle: { max: 255, required: false },
    },
    LibraryFee: {
        createdByName: { max: 255, required: false },
        kind: { max: 12, required: false },
        label: { max: 255, required: false },
        reason: { max: 500, required: false },
        receipt: { max: 60, required: false },
        state: { max: 10, required: false },
    },
    LibraryHold: {
        state: { max: 18, required: false },
    },
    LibraryImport: {
        createdByName: { max: 255, required: false },
        fileKey: { max: 64, required: false },
        fileName: { max: 255, required: false },
        format: { max: 10, required: false },
        state: { max: 10, required: false },
        target: { max: 12, required: false },
    },
    LibraryInventory: {
        closedByName: { max: 255, required: false },
        kind: { max: 10, required: false },
        label: { max: 160, required: false },
        openedByName: { max: 255, required: false },
        state: { max: 10, required: false },
    },
    LibraryInventoryLine: {
        barcode: { max: 40, required: false },
        expectedSituation: { max: 10, required: false },
        resolution: { max: 14, required: false },
        seenByName: { max: 255, required: false },
        seenCondition: { max: 10, required: false },
    },
    LibraryItem: {
        acquisitionMode: { max: 10, required: false },
        barcode: { max: 40, required: false },
        condition: { max: 10, required: false },
        cote: { max: 60, required: false },
        inventoryNumber: { max: 20, required: false },
        invoiceNumber: { max: 60, required: false },
        loanStatus: { max: 10, required: false },
        rfid: { max: 40, required: false },
        situation: { max: 10, required: false },
        supplier: { max: 160, required: false },
        withdrawnReason: { max: 255, required: false },
    },
    LibraryItemEvent: {
        byName: { max: 255, required: false },
        kind: { max: 12, required: false },
    },
    LibraryLoan: {
        byName: { max: 255, required: false },
        conditionIn: { max: 10, required: false },
        conditionOut: { max: 10, required: false },
        desk: { max: 60, required: false },
        forClass: { max: 160, required: false },
        overrideReason: { max: 500, required: false },
        returnedByName: { max: 255, required: false },
        state: { max: 10, required: false },
    },
    LibraryLocation: {
        code: { max: 30, required: false },
        label: { max: 120, required: false },
        path: { max: 600, required: false },
        status: { max: 10, required: false },
    },
    LibraryLocationKind: {
        code: { max: 30, required: false },
        label: { max: 80, required: false },
    },
    LibraryMembership: {
        cancelReason: { max: 255, required: false },
        formula: { max: 14, required: false },
        state: { max: 10, required: false },
    },
    LibraryPolicy: {
        docType: { max: 20, required: false },
        loanStatus: { max: 10, required: false },
        penaltyMode: { max: 10, required: false },
    },
    LibraryReader: {
        suspensionReason: { max: 255, required: false },
    },
    LibraryReaderCategory: {
        code: { max: 30, required: false },
        cycleCode: { max: 30, required: false },
        formula: { max: 14, required: false },
        label: { max: 120, required: false },
        population: { max: 10, required: false },
    },
    LibraryReminder: {
        byName: { max: 255, required: false },
    },
    LibraryShelfRange: {
        fromCote: { max: 30, required: false },
        label: { max: 160, required: false },
        toCote: { max: 30, required: false },
    },
    LibrarySuggestion: {
        authors: { max: 255, required: false },
        byName: { max: 255, required: false },
        isbn: { max: 13, required: false },
        note: { max: 500, required: false },
        origin: { max: 10, required: false },
        state: { max: 10, required: false },
        title: { max: 500, required: false },
    },
    LibraryWork: {
        originalTitle: { max: 500, required: false },
        title: { max: 500, required: false },
    },
    MarkCorrection: {
        absenceAfter: { max: 80, required: false },
        absenceBefore: { max: 80, required: false },
        correctedByName: { max: 255, required: false },
        reason: { max: 500, required: true },
    },
    MentionBand: {
        label: { max: 60, required: true },
    },
    MentionScale: {
        name: { max: 120, required: true },
    },
    MenuItem: {
        code: { max: 80, required: true },
        icon: { max: 60, required: false },
        module: { max: 60, required: false },
        requiredPermission: { max: 80, required: false },
        route: { max: 255, required: false },
    },
    MenuItemTranslation: {
        label: { max: 255, required: true },
    },
    Notification: {
        alertKey: { max: 160, required: false },
        body: { max: 20000, required: true },
        senderName: { max: 255, required: false },
        subject: { max: 160, required: true },
    },
    NotificationReply: {
        authorName: { max: 255, required: false },
        body: { max: 5000, required: true },
    },
    NotificationType: {
        code: { max: 30, required: false },
        label: { max: 80, required: true },
    },
    Offer: {
        description: { max: 8000, required: false },
        duration: { max: 60, required: false },
        place: { max: 160, required: false },
        title: { max: 160, required: true },
    },
    Organisation: {
        acronym: { max: 10, required: false },
        fax: { max: 30, required: false },
        legalForm: { max: 120, required: false },
        name: { max: 255, required: true },
        notes: { max: null, required: false },
    },
    PasswordToken: {
        tokenHash: { max: 64, required: false },
    },
    PayAdjustment: {
        createdByName: { max: 255, required: false },
        label: { max: 255, required: true },
    },
    PayStatement: {
        currency: { max: 3, required: false },
        number: { max: 60, required: false },
        paidByName: { max: 255, required: false },
        paidReference: { max: 80, required: false },
        validatedByName: { max: 255, required: false },
    },
    Payment: {
        bank: { max: 120, required: false },
        comment: { max: 500, required: false },
        drawer: { max: 160, required: false },
        number: { max: 40, required: false },
        reference: { max: 60, required: false },
    },
    PaymentSchedule: {
        name: { max: 80, required: true },
    },
    PayrollSettings: {
        statementPattern: { max: 60, required: true },
    },
    Permission: {
        code: { max: 80, required: true },
        module: { max: 60, required: false },
    },
    PermissionTranslation: {
        label: { max: 255, required: true },
    },
    Person: {
        firstNames: { max: 120, required: true },
        lastName: { max: 80, required: true },
        nationalIdNumber: { max: 20, required: false },
        occupation: { max: 255, required: false },
        passportNumber: { max: 15, required: false },
        photoPath: { max: 255, required: false },
    },
    PersonAddress: {
        city: { max: 120, required: false },
        country: { max: 120, required: false },
        postalCode: { max: 20, required: false },
        street: { max: 255, required: true },
    },
    PersonEmail: {
        address: { max: 180, required: true },
    },
    PersonPhone: {
        number: { max: 30, required: true },
    },
    PlanningEvent: {
        label: { max: 160, required: false },
        overrideByName: { max: 255, required: false },
        overrideReason: { max: 255, required: false },
        rollTakenByName: { max: 255, required: false },
        rollValidatedByName: { max: 255, required: false },
        statusReason: { max: 255, required: false },
    },
    PortalBankAccount: {
        pendingRib: { max: 34, required: false },
        refusal: { max: 255, required: false },
        rib: { max: 34, required: false },
        verifiedByName: { max: 255, required: false },
    },
    PortalCalendarLink: {
        digest: { max: 64, required: false },
    },
    PortalHoursReport: {
        answer: { max: null, required: false },
        handledByName: { max: 255, required: false },
        month: { max: 7, required: false },
        note: { max: null, required: false },
    },
    PortalSettings: {
        paymentInfo: { max: null, required: false },
        teacherWelcome: { max: null, required: false },
        welcome: { max: null, required: false },
    },
    Product: {
        abbreviation: { max: 40, required: false },
        code: { max: 30, required: true },
        description: { max: 20000, required: false },
        name: { max: 255, required: true },
        objectives: { max: 20000, required: false },
    },
    RefreshToken: {
        ipAddress: { max: 45, required: false },
        tokenHash: { max: 64, required: false },
        userAgent: { max: 255, required: false },
    },
    RegulationProfile: {
        name: { max: 120, required: true },
    },
    RegulationTestCase: {
        expectedStatus: { max: 4, required: false },
        label: { max: 160, required: true },
    },
    RegulationVersion: {
        createdByName: { max: 255, required: false },
        decidedByName: { max: 255, required: false },
        decisionComment: { max: 2000, required: false },
        reason: { max: 2000, required: false },
        submittedByName: { max: 255, required: false },
    },
    RelationsAgreement: {
        documentName: { max: 160, required: false },
        note: { max: 5000, required: false },
        terminationReason: { max: 255, required: false },
        title: { max: 255, required: true },
    },
    RelationsAgreementCommitment: {
        label: { max: 255, required: true },
        quantity: { max: 60, required: false },
    },
    RelationsAgreementType: {
        label: { max: 120, required: true },
    },
    RelationsAlumniPosition: {
        city: { max: 120, required: false },
        country: { max: 120, required: false },
        jobTitle: { max: 255, required: false },
        organisationName: { max: 255, required: false },
    },
    RelationsContactFunction: {
        label: { max: 120, required: true },
    },
    RelationsExchange: {
        authorName: { max: 255, required: false },
        body: { max: 10000, required: false },
        subject: { max: 255, required: true },
    },
    RelationsOrgType: {
        label: { max: 120, required: true },
    },
    RelationsProfile: {
        city: { max: 120, required: false },
        website: { max: 255, required: false },
    },
    RelationsProspect: {
        objective: { max: 255, required: true },
    },
    RelationsProspectStage: {
        label: { max: 120, required: true },
    },
    RelationsProspectStep: {
        byName: { max: 255, required: false },
        stageLabel: { max: 120, required: false },
    },
    RelationsSector: {
        label: { max: 120, required: true },
    },
    RelationsSurveyToken: {
        createdByName: { max: 255, required: false },
        tokenHash: { max: 64, required: false },
    },
    RequestEvent: {
        actorName: { max: 255, required: false },
        note: { max: 2000, required: false },
        stepLabel: { max: 120, required: false },
    },
    RequestFile: {
        mime: { max: 60, required: false },
        name: { max: 160, required: true },
        uploadedByName: { max: 255, required: false },
    },
    RequestMessage: {
        authorName: { max: 255, required: false },
        body: { max: 4000, required: true },
    },
    RequestTeam: {
        label: { max: 120, required: true },
        roleCode: { max: 60, required: false },
    },
    RequestType: {
        color: { max: 7, required: false },
        guidance: { max: 2000, required: false },
        label: { max: 120, required: true },
    },
    RequestTypeStep: {
        label: { max: 120, required: true },
    },
    ResponsibleType: {
        label: { max: 80, required: true },
    },
    ResultDecision: {
        mention: { max: 60, required: false },
        outcome: { max: 24, required: false },
    },
    ResultLine: {
        priorOrigin: { max: 160, required: false },
        status: { max: 4, required: false },
    },
    ResultRun: {
        computedByName: { max: 255, required: false },
        engineVersion: { max: 20, required: false },
        reason: { max: 2000, required: false },
    },
    Role: {
        code: { max: 60, required: true },
        copiedFrom: { max: 60, required: false },
        description: { max: 2000, required: false },
    },
    RoleTranslation: {
        label: { max: 255, required: true },
    },
    Room: {
        kind: { max: 60, required: false },
        name: { max: 80, required: true },
    },
    SharedDocument: {
        createdByName: { max: 255, required: false },
        title: { max: 200, required: false },
    },
    SharedDocumentVersion: {
        createdByName: { max: 255, required: false },
        fileKey: { max: 64, required: false },
        fileName: { max: 200, required: false },
        mime: { max: 120, required: false },
    },
    SkillsActivity: {
        label: { max: 160, required: false },
    },
    SkillsDeposit: {
        fileName: { max: 160, required: false },
        mime: { max: 120, required: false },
        note: { max: null, required: false },
    },
    SkillsFinal: {
        comment: { max: null, required: false },
        validatedByName: { max: 255, required: false },
    },
    SkillsFramework: {
        createdByName: { max: 255, required: false },
        description: { max: null, required: false },
        name: { max: 160, required: false },
        targetCode: { max: 30, required: false },
        targetLabel: { max: 255, required: false },
    },
    SkillsNode: {
        code: { max: 20, required: false },
        description: { max: null, required: false },
        label: { max: 255, required: false },
    },
    SkillsRating: {
        comment: { max: null, required: false },
        ratedByName: { max: 255, required: false },
    },
    StructureLevel: {
        label: { max: 60, required: true },
    },
    Student: {
        enrolmentNumber: { max: 20, required: false },
        kenrolIdentifier: { max: 20, required: false },
        massarCode: { max: 30, required: false },
        nationalCode: { max: 30, required: false },
        observations: { max: 255, required: false },
    },
    StudentDiploma: {
        city: { max: 120, required: false },
        mention: { max: 60, required: false },
        school: { max: 255, required: false },
    },
    StudentNumbering: {
        pattern: { max: 60, required: false },
    },
    Tax: {
        name: { max: 60, required: true },
    },
    Teacher: {
        payrollNumber: { max: 40, required: false },
    },
    TeacherCategory: {
        label: { max: 80, required: true },
    },
    TeacherContract: {
        createdByName: { max: 255, required: false },
        documentName: { max: 160, required: false },
        note: { max: 4000, required: false },
    },
    TeacherContractType: {
        label: { max: 80, required: true },
    },
    TeacherDiploma: {
        city: { max: 120, required: false },
        label: { max: 160, required: true },
        school: { max: 250, required: false },
    },
    TeachingType: {
        code: { max: 20, required: true },
        color: { max: 7, required: false },
        label: { max: 80, required: true },
    },
    TrainingCenter: {
        code: { max: 20, required: true },
        name: { max: 255, required: true },
    },
    TrainingCycle: {
        code: { max: 20, required: true },
        name: { max: 255, required: true },
    },
    TrainingDomain: {
        code: { max: 20, required: true },
        name: { max: 255, required: true },
    },
    TrainingLevel: {
        code: { max: 20, required: true },
        label: { max: 120, required: true },
    },
    TrainingTrack: {
        comment: { max: 2000, required: false },
        name: { max: 160, required: true },
    },
    TwoFactorChallenge: {
        emailCodeHash: { max: 64, required: false },
        tokenHash: { max: 64, required: false },
    },
    TwoFactorRecoveryCode: {
        codeHash: { max: 64, required: false },
    },
    UserAccount: {
        avatarMime: { max: 20, required: false },
        avatarVersion: { max: 16, required: false },
        displayName: { max: 255, required: true },
        email: { max: 180, required: true },
        emailCanonical: { max: 180, required: false },
        passwordHash: { max: 255, required: false },
        totpSecret: { max: 255, required: false },
    },
    UserIdentity: {
        emailAtProvider: { max: 180, required: false },
        subject: { max: 255, required: false },
    },
    UserRequest: {
        closingReason: { max: 2000, required: false },
        number: { max: 30, required: false },
        subject: { max: 160, required: true },
    },
    Venue: {
        address: { max: 255, required: false },
        name: { max: 120, required: true },
    },
} as const satisfies Readonly<Record<string, Readonly<Record<string, Limit>>>>;
